module.exports = __webpack_public_path__ + "img/removals_variant_1x.7bef834.webp";